import { METRIC_TYPE } from '@nx/state';

import type { ChartWidgetPartialProps } from '../fullstack-chart-props';
import { BytesChartConfig, IntChartConfig } from '../helpers';

const CPUTotalProps: ChartWidgetPartialProps = {
  title: 'CPU Usage',
  subtitle: 'Total',
  yLabel: '%',
  metricType: METRIC_TYPE.Gauge,
  metricName: 'fleet_management_cpu_usage',
  chartType: 'HOST',
  referenceMetricConfig: {
    toggledByDefault: true,
    name: 'fleet_management_cpu_core_count',
    type: METRIC_TYPE.Gauge,
    aggregation: 'MAX',
    hidden: true,
  },
  ...IntChartConfig,
};

const MemoryUsedChartProps: ChartWidgetPartialProps = {
  title: 'Memory usage',
  yLabel: 'Memory',
  metricName: 'fleet_management_memory_used',
  metricType: METRIC_TYPE.Gauge,
  chartType: 'HOST',
  referenceMetricConfig: {
    toggledByDefault: true,
    name: 'fleet_management_total_memory',
    type: METRIC_TYPE.Gauge,
    aggregation: 'MAX',
    hidden: false,
  },
  ...BytesChartConfig,
};

const StorageUsedChartProps: ChartWidgetPartialProps = {
  title: 'Storage',
  subtitle: 'Total',
  yLabel: 'Space',
  metricType: METRIC_TYPE.Gauge,
  metricName: 'fleet_management_neo4j_store_size_total',
  chartType: 'HOST',
  ...BytesChartConfig,
};

export const DeploymentResourcesCharts = [CPUTotalProps, MemoryUsedChartProps, StorageUsedChartProps];
